import { useEffect } from 'react'
import { useTranslation } from '@mc/i18n'
import { paths } from '@mc/paths'
import {
  Locations,
  Product,
  NavigationEvents,
  trackExperimentViewed,
} from '@mc/track-event'
import Link from 'components/Link'
import { MCCERTS_NAVIGATION_TESTING_PRE_PAYWALL_EXP_FLAG } from 'experiments/mccerts-280_v1/constants'
import { trackNavigationClick } from '../events'

export const CertificatesLink = ({
  className = '',
  location = Locations.NAVIGATION,
  product = Product.CERTIFICATES,
}: {
  className?: string
  location?: (typeof Locations)[keyof typeof Locations]
  product?: (typeof Product)[keyof typeof Product]
}) => {
  const { t } = useTranslation('@mc/next')

  const ctaCopy = t('nav.cta.certificates')

  useEffect(() => {
    trackExperimentViewed(MCCERTS_NAVIGATION_TESTING_PRE_PAYWALL_EXP_FLAG)
  }, [])

  const handleCertificatesClick = () => {
    trackNavigationClick(
      ctaCopy,
      NavigationEvents.LEVELS.PRIMARY,
      location,
      product,
    )
  }

  return (
    <Link
      href={paths.certificates}
      className={className}
      onClick={handleCertificatesClick}
      passHref
      newTab
    >
      {ctaCopy}
    </Link>
  )
}
